import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black py-12 px-4" data-id="element-54">
      <div className="max-w-4xl mx-auto text-center space-y-4" data-id="element-55">
        <p className="font-display text-xl text-mint font-semibold" data-id="element-56">
          Salud en tu Plato™
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm" data-id="element-57">
          <a href="mailto:soporte@saludentuplato.com" className="flex items-center gap-2 text-white/50 hover:text-mint transition-colors" data-id="element-58">
            <MailIcon className="w-4 h-4" data-id="element-59" />
            soporte@saludentuplato.com
          </a>
          <a href="https://instagram.com/saludentuplato" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/50 hover:text-mint transition-colors" data-id="element-60">
            <InstagramIcon className="w-4 h-4" data-id="element-61" />
            @saludentuplato
          </a>
        </div>
        <p className="text-xs text-white/30" data-id="element-62">
          © Salud en tu Plato™ 2026 — Todos los derechos reservados. Prohibida
          la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}